// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"725e0c80","776":"ff2dfaa9","808":"b2aabc79","884":"38b30ba9","922":"c811a702"}[chunkId] + ".chunk.js";
};